const PARTICLES = ['de', 'da', 'do', 'das', 'dos', 'e', 'di', 'du', 'del', 'van', 'von']

function capitalize(word:string):string {
    // Nomes compostos com hífen ou apóstrofo ("Ana-Maria", "D'Ávila") capitalizam cada parte.
    return word.replace(/(^|[-'’])(\S)/g, (_m, sep, ch) => sep + ch.toLocaleUpperCase('pt-BR'))
}

/**
 * Padroniza a caixa de um nome de pessoa só para exibição: os canais entregam
 * "ARNALDO G", "luiz gonçalves" e afins. Partículas (de, da, dos...) ficam em
 * minúsculo fora da primeira posição. Nomes mascarados pelo canal (com "*")
 * voltam como vieram, porque não dá para saber a caixa original.
 */
export function formatPersonName(name:string|undefined|null):string {
    const value = String(name || '').trim()

    if (!value || value.includes('*')) {
        return value
    }

    return value
        .toLocaleLowerCase('pt-BR')
        .split(/\s+/)
        .map((word, index) => (index > 0 && PARTICLES.includes(word)) ? word : capitalize(word))
        .join(' ')
}
